// Compact ★ average-rating badge shown under a product image on cards.
// Renders NOTHING when the product has no reviews (count 0 / missing) so a fresh
// catalog stays clean. `rating` is a { avg, count } object from useAvgRatings.
export function RatingBadge({ rating, style, dark = false }) {
  if (!rating || !rating.count) return null;
  return (
    <div style={{ display:"inline-flex", alignItems:"center", gap:3, fontSize:11, fontWeight:700,
      color: dark ? "rgba(255,255,255,0.9)" : "var(--ink)", lineHeight:1, ...style }}>
      <span style={{ color:"#F59E0B" }}>★</span>
      <span>{Number(rating.avg).toFixed(1)}</span>
      <span style={{ color: dark ? "rgba(255,255,255,0.5)" : "var(--ink-soft)", fontWeight:500 }}>
        ({rating.count})
      </span>
    </div>
  );
}
